import Box from 'components/box/Box';
import IconButton from 'components/iconbutton/IconButton';
import GlassIcon from 'components/icons/svg/GlassIcon';
import TrophyIcon from 'components/icons/svg/TrophyIcon';
import SqLogo from 'components/logo/SqLogo';
import { IPHONE_APP_SCREENSHOT } from 'constants/constants';
import { SqRoutes } from 'constants/Routes';
import { useAppSelector } from 'hooks/hooks';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getFbSqUser, getIsUserLoggedIn } from 'slices/SqUserSlice';
import { ASComponentSize } from 'types/App.types';
import styles from './FootballField.module.scss';

type FootballFieldProps = {
  className?: string;
  isActive?: boolean;
};

const newUserTitle = 'Welcome to our inaugural release!';
const returningUserTitle = 'Welcome back {{playerName}}';

const newUserMessage =
  'Squares is a fun multiplayer game which allows participants to pick a set of squares from a grid of 100. Once all the squares are picked, and actual football game begins, two sets of random numbers between 0 and 9 will be generated. Each set represents one of the two axis on a grid, to identify each square. Score from the game is used to determine which number on each of the axis should be used. The last digit of the score for each team is matched with the same number on the axis representing each team. A square that lies in the crosshair of these two number is a winning square at the end of the quarter.';
const returningUserMessage =
  'Head over to the Lobby area to find a game to join, create a new game, or resume a game in progress';

const FootballField: React.FC<FootballFieldProps> = ({ className = '' }) => {
  const baseCls = `${styles.FootballField} ${className}`;
  const navigate = useNavigate();

  const isLoggedIn = useAppSelector(getIsUserLoggedIn);
  const user = useAppSelector(getFbSqUser);
  const onClickNavigatedToJoin = () => (isLoggedIn ? navigate(SqRoutes.Lobby) : navigate(SqRoutes.Register));
  const onClickNavigatedToLogin = () => (isLoggedIn ? navigate(SqRoutes.Lobby) : navigate(SqRoutes.Login));

  return (
    <div className={baseCls}>
      <SqLogo className={styles.FootballFieldLogo} />
      <Box style={{ display: 'block' }}>
        <h1 className={styles.FootballFieldTitle}>
          {isLoggedIn ? returningUserTitle.replace('{{playerName}}', user?.name ?? '') : newUserTitle}
        </h1>
        <img className={styles.FootballAppScreenshot} src={IPHONE_APP_SCREENSHOT} alt="app screenshot" />
        <p className={styles.FootballFieldMessage}>{isLoggedIn ? returningUserMessage : newUserMessage}</p>
        <div className={styles.FootballFieldActiveButtons}>
          <IconButton size={ASComponentSize.Large} onClick={onClickNavigatedToJoin}>
            <TrophyIcon size={40} />
            {`${isLoggedIn ? 'LOBBY' : 'JOIN'}`}
          </IconButton>

          {!isLoggedIn && (
            <IconButton size={ASComponentSize.Large} onClick={onClickNavigatedToLogin}>
              <GlassIcon size={40} />
              LOGIN
            </IconButton>
          )}
        </div>
      </Box>
    </div>
  );
  // };

  // return isActive ? <ModalScreen hideBgOverlay>{renderFootball()}</ModalScreen> : null;
};

export default FootballField;
